
import { useState, useCallback } from 'react';
import { clearGameCompletionState } from "@/lib/storage/local-storage";
import { useToast } from "@/components/ui/use-toast";

export function useTestMode() {
  const [isTestMode, setIsTestMode] = useState<boolean>(
    localStorage.getItem("test_mode_enabled") === "true"
  );
  const { toast } = useToast();
  
  // Toggle test mode on/off
  const toggleTestMode = useCallback(() => {
    const newValue = !isTestMode;
    setIsTestMode(newValue);
    localStorage.setItem("test_mode_enabled", newValue ? "true" : "false");
    
    toast({
      title: newValue ? "Dev Mode Enabled" : "Dev Mode Disabled",
      duration: 2000,
    });
    
    console.log("Test mode toggled:", newValue);
  }, [isTestMode, toast]);
  
  // Clear all game completion state
  const clearGameState = useCallback(() => {
    clearGameCompletionState();
    
    toast({
      title: "Game State Cleared",
      description: "Game completion status has been reset",
      duration: 2000,
    });
    
    console.log("Game state cleared");
    
    // Force reload to ensure all components update with new state
    setTimeout(() => window.location.reload(), 500);
  }, [toast]);
  
  // Clear just the email to force new user flow
  const clearEmailOnly = useCallback(() => {
    localStorage.removeItem("user_email");
    
    toast({
      title: "Email Cleared",
      description: "You can now enter a new email",
      duration: 2000,
    });
    
    console.log("Email cleared from localStorage");
    
    // Force reload to ensure all components update with new state
    setTimeout(() => window.location.reload(), 500);
  }, [toast]);
  
  return {
    isTestMode,
    toggleTestMode,
    clearGameState,
    clearEmailOnly
  };
}

